module.exports = __webpack_public_path__ + "img/osboot_sample_texture_500x500__01.01bc08c0.jpg";